<!-- ion-content вынесен в отдельный компонент с возможностью вставить ion-refresher по селекту в ng-content из-за того,
что для корректного отображения refresher’a необходима четкая вложенность ion-refresher’а в ion-content и никак иначе,
то есть не должно быть никакой вложенности DOM-элементов.
Благодаря данному решению, можно вставлять компоненты в ion-page-container(через router-outlet и не только),
которые в свою очередь можно обернуть в ion-page-content, непосредственно в самой компоненте,
и использовать на каждую компоненту свой ion-refresher -->

<ion-content
  appIonScrollBar
  [scrollEvents]="true"
  (ionScroll)="onScroll($any($event))"
  [forceOverscroll]="forceOverscroll"
>
  <ng-content select="[refresh]"></ng-content>
  <ion-grid>
    <ion-row>
      @if (!isModalView) {
        <ion-col class="page-content__col-menu" size="2.5">
          <div class="menu-wrapper">
            @for (option of menuOptions; track option) {
              @if (isUrlExternal(option.url)) {
                <a class="menu-item" target="_blank" [href]="option.url">
                  <ng-container *ngTemplateOutlet="menuItem"></ng-container>
                </a>
              }
              @if (!isUrlExternal(option.url)) {
                <a
                  class="menu-item"
                  (click)="navigate(option.url)"
                  [routerLink]="['/', dashboardUrl, option.url]"
                >
                  <ng-container *ngTemplateOutlet="menuItem"></ng-container>
                </a>
              }
              <ng-template #menuItem>
                <div class="menu-item__info">
                  <img [src]="option.img" />
                  <app-text
                    [textSize]="TextSizes.h2Menu"
                    [textType]="TextType.base"
                    [text]="option.name"
                  ></app-text>
                  @if (option.name === 'Библиотека') {
                    <app-svg icon="open-in-new"></app-svg>
                  }
                </div>
                @if (option.counterName && { data: counters$ | async }; as counters) {
                  @if (counters.data?.[option.counterName]; as menuCounterValue) {
                    <div class="menu-item__counter">
                      <app-text
                        [textSize]="TextSizes.qty"
                        [textType]="TextType.base"
                        [text]="menuCounterValue.toString()"
                      ></app-text>
                    </div>
                  }
                }
              </ng-template>
            }
          </div>
        </ion-col>
      }
      <ion-col class="page-content__col-content">
        <ng-content></ng-content>
      </ion-col>
      @if (!isModalView && isBirthdaysColShow) {
        <ion-col class="page-content__col-birthdays" size="3"></ion-col>
      }
    </ion-row>
  </ion-grid>
</ion-content>
